import { useTranslation } from "react-i18next";
import { Col, Row } from 'react-bootstrap';
import PageTitle from "../../../layouts/PageTitle";
import CashHistory from "../../../components/Custom/CashFlow/Cash/CashHistory";

const CashList = () => {

    const { t } = useTranslation();

    return (
        <>
            <PageTitle activeMenu={t('cash_flow.cash_registers')} motherMenu={t('cash_flow.label')} />
            <Row>
                <Col className="col-md-12">
                    <CashHistory/>
                </Col>
            </Row>
        </>
    );
}

export default CashList;